export type GateLogType = 'VISIT' | 'PARCEL_IN' | 'PARCEL_OUT' | 'OTHER';

export interface CompanyGateLog {
  logId: number;
  logDate: string;
  logTime?: string | null;
  logType: GateLogType | string;
  logTypeLabel?: string | null;
  title: string;
  partyName?: string | null;
  contactName?: string | null;
  contactPhone?: string | null;
  trackingNo?: string | null;
  memo?: string | null;
  createdUserId?: number | null;
  createdUserName?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface CompanyGateLogPayload {
  logDate: string;
  logTime?: string;
  logType: GateLogType | string;
  title: string;
  partyName?: string;
  contactName?: string;
  contactPhone?: string;
  trackingNo?: string;
  memo?: string;
}

export const GATE_LOG_TYPE_OPTIONS: { value: GateLogType; label: string }[] = [
  { value: 'VISIT', label: '방문' },
  { value: 'PARCEL_IN', label: '택배입고' },
  { value: 'PARCEL_OUT', label: '택배출고' },
  { value: 'OTHER', label: '기타' },
];

export function gateLogTypeLabel(type?: string | null) {
  const found = GATE_LOG_TYPE_OPTIONS.find((o) => o.value === type);
  return found?.label || type || '-';
}

/** HH:mm:ss → HH:mm */
export function formatGateLogTime(value?: string | null) {
  if (!value?.trim()) return '';
  return value.trim().slice(0, 5);
}
